import scrollLock from './functions/_scrollLock.js' // スクロールロック
/*
########  ####    ###    ##        #######   ######
##     ##  ##   ##   ##  ##       ##     ## ##
##     ##  ##  ##     ## ##       ##     ## ##   ####
##     ##  ##  ######### ##       ##     ## ##    ##
########  #### ##     ## ########  #######   ######

<div id="modalOverlay" class="md-overlay md-overlay--dialog"></div>
<div id="js-dialog" class="modal modal--dialog">
    <div class="modal__frame modal__frame--dialog">
        <div class="modal__box modal__box--dialog dialog">
            <div id="js-dialog-text" class="dialog__text">
                よろしいですか？
            </div>
            <div class="dialog__list flex bet break">
                <button type="button" class="js-dialog-no js-dialog-close dialog__btn md-btn blueLine">
                    キャンセル
                </button>
                <button type="button" class="js-dialog-yes js-dialog-close dialog__btn md-btn graBlue">
                    OK
                </button>
            </div>
        </div>
    </div>
</div>

window.dialogOpen('○○をクリアします', 'OK', 'キャンセル', 'js-dialogAgree', dialogData)
window.addEventListener('click', function (e) {
  // 指定のIDを持つ
  if (e.target.id === 'js-dialogAgree') {
    carClear(e.target.dataset.dialog)
  }
})
*/
const modalOverlay = document.getElementById('modalOverlay') // ダイアログ用オーバーレイ
const dialog = document.getElementById('js-dialog') // ダイアログ
window.dialogOpen = function (title, text, btnHTML = '') {
  // ダイアログモーダルを開く
  dialog.classList.add('active')
  modalOverlay.classList.add('active')
  scrollLock('body', '#modalOverlay')

  // 文言を決める
  const dialogTitle = document.getElementById('js-dialog-title')
  const dialogText = document.getElementById('js-dialog-text')
  const dialogBtn = document.getElementById('js-dialog-btn')
  dialogTitle.innerHTML = title
  dialogText.innerHTML = text
  dialogBtn.innerHTML = btnHTML
}

// ダイアログ撤去
window.addEventListener('click', (e) => {
  if (!e.target.closest('.js-dialog-close')) {
    return
  }
  e.preventDefault()
  dialog.classList.remove('active')
  modalOverlay.classList.remove('active')
  scrollLock('body', '#modalOverlay')
})
